export const generateArray = (length, base) => {
  let result = [];
  for (let i = base; i <= length * base; i += base) {
    result.push(i);
  }
  return result;
};
